var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgComment = function SvgComment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messages Bubble"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41667 0.750009C6.37711 0.74851 5.35609 1.02524 4.45957 1.55148C3.56305 2.07771 2.82369 2.83429 2.31822 3.74268C1.81275 4.65108 1.55959 5.67819 1.58501 6.71743C1.61043 7.75668 1.9135 8.77019 2.46278 9.65279L0.75 13.25L4.34667 11.5372C5.11372 12.0141 5.98105 12.3064 6.88031 12.391C7.77956 12.4756 8.68618 12.3502 9.52873 12.0248C10.3713 11.6993 11.1267 11.1826 11.7356 10.5154C12.3444 9.84825 12.79 9.0488 13.0373 8.18007C13.2845 7.31134 13.3266 6.39706 13.1603 5.50928C12.994 4.62149 12.6238 3.78445 12.0789 3.06411C11.534 2.34377 10.8292 1.75981 10.0202 1.35824C9.21114 0.956664 8.31989 0.748453 7.41667 0.750009Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "comment.993671ac9c964d2ffd8d38e50edc1238.svg";